import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Point, Voucher, VoucherCategory } from 'src/app/models/point';
import { RedeemPopupComponent } from '../redeem-popup/redeem-popup.component';
import { PointService } from 'src/app/services/point.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-list-voucher',
  templateUrl: './list-voucher.component.html',
  styleUrls: ['./list-voucher.component.css']
})
export class ListVoucherComponent implements OnInit {

  public point: Point;
  public description = '';
  public vouchers: Voucher[] = [];
  public categories: VoucherCategory[] = [];
  public page = 1;
  public category = '';
  public title = '';
  public isLoading = false;
  public canShowMore = false;
  count417 = 0;

  @ViewChild('redeemModal') redeemModal: RedeemPopupComponent;

  constructor(
    private pointService: PointService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getPoint();
    this.getCategory();
    this.getVoucher();
    this.getDescription();
  }

  getPoint() {
    this.pointService.getPoint(
      (data) => {
        this.point = data;
      },
      (err) => {
        console.log(err);
      });
  }

  getCategory() {
    this.pointService.getCategory(
      (data) => {
        this.categories = data;
      },
      (err) => {
        console.log(err);
      });
  }

  getVoucher() {
    this.isLoading = true;
    this.pointService.getVoucher(this.page, this.category, this.title,
      (data) => {
        this.vouchers = data;
        if (data.length >= 10) {
          this.canShowMore = true;
        } else {
          this.canShowMore = false;
        }
      },
      (err) => {
        console.log(err);
      });
    this.isLoading = false;
  }

  searchVoucher(event: any) {
    this.isLoading = true;
    this.title = event.target.value;
    this.page = 1;
    this.pointService.getVoucher(this.page, this.category, this.title,
      (data) => {
        this.vouchers = data;
        if (data.length >= 10) {
          this.canShowMore = true;
        } else {
          this.canShowMore = false;
        }
      },
      (err) => {
        console.log(err);
      });
    this.isLoading = false;
  }

  filterCategory() {
    this.isLoading = true;
    this.page = 1;
    this.pointService.getVoucher(this.page, this.category, this.title,
      (data) => {
        this.vouchers = data;
        if (data.length >= 10) {
          this.canShowMore = true;
        } else {
          this.canShowMore = false;
        }
      },
      (err) => {
        console.log(err);
      });
    this.isLoading = false;
  }

  showMore() {
    this.isLoading = true;
    this.canShowMore = false;
    this.page += 1;

    this.pointService.getVoucher(this.page, this.category, this.title,
      (data) => {
        data.forEach(item => {
          this.vouchers.push(item);
        });

        if (data.length >= 10) {
          this.canShowMore = true;
        }

        this.isLoading = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getDescription() {
    this.pointService.getDescription(
      (data) => {
        this.description = data;
      },
      (err) => {
        console.log(err);
      });
  }

  public showDescription(): void {
    $('#description').modal('show');
  }

  public closeDescription(): void {
    $('#description').modal('hide');
  }

  public redeemVoucher(voucher: Voucher): void {
    this.redeemModal.showVoucher(voucher);
  }

  public navigateToVoucherDetail(voucher: Voucher): void {
    this.router.navigate([`/detail-voucher/${btoa(JSON.stringify(voucher))}`]);
  }
}
